import '../css/App.css';
import Canvas from './Canvas';
import DataManager from './DataManager';
import ScrollGraphic from './ScrollGraphic';
import UI from './UI';

export default class App {
	constructor() {}

	async init() {
		window.addEventListener('contextmenu', (e: MouseEvent) => e.preventDefault());

		const ui = new UI();
		ui.init();

		const dataManager = new DataManager();
		dataManager.init();

		const canvas = new Canvas();
		await canvas.init();
		// window.canvas = canvas;
		const scrollGraphic = new ScrollGraphic();
		scrollGraphic.init();

		setTimeout(() => {
			window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
		}, 1);

		console.log('App init');
	}
}
